import angular from 'angular';
import components from './components';

export default angular.module('corpActionsMenus.scenes', [components]).name;
